/* eslint-disable @typescript-eslint/no-require-imports */
"use client";

import * as React from "react";
import "@/app/globals.css";
import FormEducationOpportunity from "./Components/FormEducationOpportunity";
import HeaderRevenda from "@/components/ui/headerRevenda";

export default function Education() {

  return (
    <>
      <div className="w-full flex flex-col justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100 items-center  m-0 p-0">
        <HeaderRevenda />
        <title>Education</title>
        <section className="relative flex flex-col items-center justify-center w-full min-h-screen mt-20">
          <div className="max-w-2xl text-center mb-8">
            <h1 className="text-3xl font-bold text-blue-900 mb-4">
              Tenho uma oportunidade para o AlertAI Education!
            </h1>
            <p className="text-lg text-gray-700">
              Preencha o formulário abaixo para anunciar uma oportunidade como revendedor autorizado do AlertAI. Ofereça soluções inovadoras de inteligência artificial aos seus clientes e faça parte da nossa rede de parceiros!
            </p>
          </div>
          <FormEducationOpportunity />
        </section>
      </div>
    </>
  );
}
